import { Button, TextField } from "@mui/material";
import { Box } from "@mui/system";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import { Fragment } from "react";
import { Controller } from "react-hook-form";

export const OutofDeliveryForm = ({ form, item }) => {
	const {
		control,
		watch,
		setValue,
		formState: { errors },
	} = form;

	const selectedSlot = watch("deliverySlot");

	const deliverySlots = [
		{
			label: "9AM - 9PM",
			range: [
				moment().set({ hour: 9, minute: 0, second: 0, millisecond: 0 }),
				moment().set({
					hour: 21,
					minute: 0,
					second: 0,
					millisecond: 0,
				}),
			],
		},
		{
			label: "9AM - 12PM",
			range: [
				moment().set({ hour: 9, minute: 0, second: 0, millisecond: 0 }),
				moment().set({
					hour: 12,
					minute: 0,
					second: 0,
					millisecond: 0,
				}),
			],
		},
		{
			label: "12PM - 3PM",
			range: [
				moment().set({
					hour: 12,
					minute: 0,
					second: 0,
					millisecond: 0,
				}),
				moment().set({
					hour: 15,
					minute: 0,
					second: 0,
					millisecond: 0,
				}),
			],
		},
		{
			label: "3PM - 6PM",
			range: [
				moment().set({
					hour: 15,
					minute: 0,
					second: 0,
					millisecond: 0,
				}),
				moment().set({
					hour: 18,
					minute: 0,
					second: 0,
					millisecond: 0,
				}),
			],
		},
		{
			label: "6 PM - 9 PM",
			range: [
				moment().set({
					hour: 18,
					minute: 0,
					second: 0,
					millisecond: 0,
				}),
				moment().set({
					hour: 21,
					minute: 0,
					second: 0,
					millisecond: 0,
				}),
			],
		},
	];

	const handleRangeSelect = ([start, end]) => {
		setValue("start_time", start, { shouldValidate: true });
		setValue("end_time", end, { shouldValidate: true });
	};
	return (
		<Fragment>
			<Box my={3}>
				<Controller
					name={`tracking_url`}
					rules={{
						required: "Tracking URL Required",
					}}
					control={control}
					render={({ field }) => (
						<TextField
							{...field}
							value={field.value ?? null}
							fullWidth
							label="Tracking URL"
							variant="outlined"
							error={Boolean(errors.tracking_url)}
							helperText={errors.tracking_url?.message}
						/>
					)}
				/>
			</Box>
			<Box my={3}>
				<Controller
					name={`tracking_number`}
					rules={{
						required: "Tracking Number Required",
					}}
					control={control}
					defaultValue={item?.tracking_number || ""}
					render={({ field }) => (
						<TextField
							{...field}
							value={field.value ?? ""}
							fullWidth
							label="Tracking Number"
							variant="outlined"
							error={Boolean(errors.tracking_number)}
							helperText={errors.tracking_number?.message}
						/>
					)}
				/>
			</Box>
			<Box my={3}>
				<LocalizationProvider dateAdapter={AdapterMoment}>
					{/* Time Pickers */}
					<Box display="flex" gap={2}>
						<Controller
							name="start_time"
							control={control}
							rules={{
								required: "Start time is required",
							}}
							render={({ field }) => (
								<TimePicker
									minTime={moment()}
									label="Start Time"
									// ampm={false}
									{...field}
									value={field.value || null}
									renderInput={(params) => (
										<TextField
											{...params}
											fullWidth
											error={!!errors.start_time}
											helperText={
												errors.start_time?.message
											}
										/>
									)}
								/>
							)}
						/>
						<Controller
							name="end_time"
							control={control}
							rules={{ required: "End time is required" }}
							render={({ field }) => (
								<TimePicker
									label="End Time"
									{...field}
									value={field.value || null}
									// ampm={false}
									minTime={watch("start_time") ?? moment()}
									renderInput={(params) => (
										<TextField
											{...params}
											fullWidth
											error={!!errors.end_time}
											helperText={
												errors.end_time?.message
											}
										/>
									)}
								/>
							)}
						/>
					</Box>
				</LocalizationProvider>
			</Box>
			<Box
				sx={{
					display: "flex",
					gap: 1,
					justifyContent: "center",
					// justifyItems: "center",
					flexWrap: "wrap",
					// mt: 2,
				}}
			>
				{deliverySlots.map((slot, i) => (
					<Button
						key={`slot-${i}`}
						size="small"
						variant={
							selectedSlot === slot.label
								? "contained"
								: "outlined"
						}
						onClick={() => {
							const isSelected = selectedSlot === slot.label;
							setValue(
								"deliverySlot",
								isSelected ? "" : slot.label,
								{
									shouldValidate: true,
								}
							);
							handleRangeSelect(slot.range);
						}}
					>
						{slot.label}
					</Button>
				))}
			</Box>

			<Box my={3}>
				<Controller
					name={`otp`}
					rules={{
						required: "OTP Required",
					}}
					control={control}
					defaultValue={""}
					render={({ field }) => (
						<TextField
							{...field}
							value={field.value ?? ""}
							fullWidth
							label="OTP"
							variant="outlined"
							error={Boolean(errors.otp)}
							helperText={errors.otp?.message}
						/>
					)}
				/>
			</Box>
		</Fragment>
	);
};
